

// Calculate Reliability Index
// https://github.com/CoSci-LLC/SlideforNETWeb/issues/22
// (mean-1)/(standard deviation)
function calculate_reliability_index(arr: number[]) {
    const mean = arr.reduce((a, b) => a + b, 0) / arr.length;

    // Assigning (value - mean) ^ 2 to every array item
    arr = arr.map((k) => {
        return (k - mean) ** 2
    })

    // Calculating the sum of updated array
    let sum = arr.reduce((acc, curr) => acc + curr, 0);

    // Calculating the variance
    //let variance = sum / arr.length

    // Returning the standard deviation
    const stddev = Math.sqrt(sum / arr.length);

    return (mean - 1) / stddev;
}

/* Assumes we are given sorted data by x. This returns null if
 * the requested data would be outside the domain.
 */
function simpleInterpolation(points: number[][], y: number) {
    // Not even going to try
    if (points.length < 1) return null;

    // If the first point in the sorted array is already bigger than [y],
    // any calculation will be outside the domain.
    if (points[0][1] > y) return null;

    // Same thing for the end of the array
    if (points[points.length - 1][1] < y) return null;

    for (let i = 0; i < points.length - 1; i++) {
        // Find the value less than and greater than [y]
        if (!(points[i][1] <= y && points[i + 1][1] >= y)) {
            console.log(`Checking ${points[i][1]} and ${points[i + 1][1]}`);
            continue;
        }
        console.debug(`Found ${points[i][1]} and ${points[i + 1][1]}`)

        // Let's create a basic linear equation
        const m = (points[i + 1][1] - points[i][1]) / (points[i + 1][0] - points[i][0]);
        const b = points[i][1] - m * i;

        console.log(`m = ${m}`)
        console.log(`b = ${b}`)

        // Solve for x, in terms of y.
        return (y - b) / m;
    }

    return null;
}

export { calculate_reliability_index, simpleInterpolation };
